jQuery.fn.insertAt = function (index, element) {
  var lastIndex = this.children().size();
  if (index < 0) {
    index = Math.max(0, lastIndex + 1 + index);
  }
  this.append(element);
  if (index < lastIndex) {
    this.children().eq(index).before(this.children().last());
  }
  return this;
};

// pseudo selector para identificar textos que possuem ellipsis
jQuery.expr[':'].ellipsed = function (obj) {
  return obj.offsetHeight < obj.scrollHeight;
};

export default {};
